import { compare } from 'compare-versions';

// Version de caisse à partir de laquelle l'application propose ses formes
// courantes : exigence à quatre valeurs sur les niveaux de menu, onglet des
// quantités.
export const VERSION_UP_TO_DATE = '5.9.3';

/**
 * Les iPads principaux : ni terminal de poche, ni simulateur.
 * @param {Array} peripherals
 * @returns {Array}
 */
export function getMasterPeripherals(peripherals) {
	return (peripherals || []).filter(
		peripheral =>
			peripheral.is_master &&
			!peripheral.handheld &&
			peripheral.model !== 'Simulator'
	);
}

/**
 * La caisse du compte est-elle à jour ?
 *
 * Deux cas répondent oui : l'iPad principal est en version courante, ou il n'y
 * a aucun périphérique — un compte sans caisse ne peut rien recevoir
 * d'obsolète, autant lui proposer les formes courantes.
 *
 * @param {Array} peripherals - state.user.peripherals
 * @returns {Boolean}
 */
export function isCashUpToDate(peripherals) {
	if (!(peripherals || []).length) {
		return true;
	}
	return getMasterPeripherals(peripherals).some(
		peripheral =>
			peripheral.version_app &&
			compare(peripheral.version_app, VERSION_UP_TO_DATE, '>=')
	);
}
